import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SORT_TYPES } from "config/filters";
import Select from "components/core/Select";
import SearchPageContext from "pages/SearchPageV1/SearchPageV1Context";

const SortSelect = ({ onChange, selected }) => {
	const { setIsFiltering } = useContext(SearchPageContext);
	const handleChange = (e) => {
		setIsFiltering(true);
		onChange(e.target.value);
	};

	return (
		<Select
			className="results-sort"
			id="sort-select"
			label="Sort By:"
			options={Object.values(SORT_TYPES)}
			onChange={handleChange}
			defaultValue={selected}
		/>
	);
};
SortSelect.propTypes = {
	selected: PropTypes.oneOf(Object.values(SORT_TYPES).map((v) => v.value)),
	onChange: PropTypes.func.isRequired
};

export default SortSelect;
